module.exports = __webpack_public_path__ + "static/media/siamese-twin.7cda16de.jpg";